// extracted by mini-css-extract-plugin
module.exports = {"open":"VoucherCodeInLine_open__z2YTY","closed":"VoucherCodeInLine_closed__vWAIe"};